(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var widget = document.querySelector('.discount-widget');
    if (!widget) return;

    var trigger = widget.querySelector('.discount-widget-trigger');
    var overlay = widget.querySelector('.discount-widget-overlay');
    var popup = widget.querySelector('.discount-widget-popup');
    var closeBtn = widget.querySelector('.discount-widget-close');
    var copyBtn = widget.querySelector('.discount-widget-copy-btn');
    var copyBtnLabel = copyBtn ? copyBtn.querySelector('span') : null;

    if (!trigger || !popup) return;

    var couponCode = widget.getAttribute('data-coupon') || '';
    var copyText = widget.getAttribute('data-copy-text') || 'Copy Code';
    var copiedText = widget.getAttribute('data-copied-text') || 'Copied!';

    function openPopup() {
      popup.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closePopup() {
      popup.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      var otherDrawer = document.querySelector('.cart-drawer.open, .wishlist-drawer.open');
      if (!otherDrawer) {
        document.body.style.overflow = '';
      }
      trigger.focus();
    }

    trigger.addEventListener('click', openPopup);

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('open')) {
        closePopup();
      }
    });

    if (copyBtn && couponCode) {
      copyBtn.addEventListener('click', function () {
        if (copyBtn.classList.contains('copied')) return;

        function onSuccess() {
          copyBtn.classList.add('copied');
          if (copyBtnLabel) copyBtnLabel.textContent = copiedText;
          setTimeout(function () {
            copyBtn.classList.remove('copied');
            if (copyBtnLabel) copyBtnLabel.textContent = copyText;
          }, 2500);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(couponCode).then(onSuccess).catch(function () {
            fallbackCopy(couponCode, onSuccess);
          });
        } else {
          fallbackCopy(couponCode, onSuccess);
        }
      });
    }

    function fallbackCopy(text, cb) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (cb) cb();
    }
  });
})();
